import * as React from "react";
import Iauto6 from "../Images/iauto6.png";
import Iauto3 from "../Images/iauto3.png";
import Iauto4 from "../Images/iauto4.png";
import Iauto5 from "../Images/iauto5.png";

function Section2() {
  return (
    <div className="flex flex-col px-16 py-10">
      <div className="self-center text-lg font-bold leading-7 uppercase text-zinc-800">
        Our Portfolio
      </div>
      <div className="self-center mt-8 text-5xl font-semibold tracking-wide text-center text-orange-400 capitalize leading-[52px] max-md:max-w-full">
        Our <span className="text-orange-400">Successive</span> Projects{" "}
      </div>
      <div className="mt-24 w-full max-md:mt-10 max-md:max-w-full">
        <div className="flex gap-5 max-md:flex-col max-md:gap-0">
          <div className="flex flex-col w-6/12 max-md:ml-0 max-md:w-full">
            <div className="flex flex-col grow pb-16 w-full rounded-2xl bg-slate-200 text-zinc-800 max-md:mt-10 max-md:max-w-full">
              <img
                loading="lazy"
                src={Iauto6}
                className="w-full aspect-[1.39] max-md:max-w-full"
              />
              <div className="flex flex-col px-16 mt-11 max-md:px-5 max-md:mt-10 max-md:max-w-full">
                <div className="text-4xl font-extrabold capitalize max-md:max-w-full">
                  Automatedenergy storage
                </div>
                <div className="mt-12 text-lg leading-7 max-md:mt-10 max-md:max-w-full">
                  leading renewable energy solutions provider that is sources
                  are harnessed across the world. Present in 18 countries across
                  Asia, Australia, Europe Africa and the Americas, Veztaz is
                  powering.
                </div>
              </div>
            </div>
          </div>
          <div className="flex flex-col ml-5 w-6/12 max-md:ml-0 max-md:w-full">
            <div className="flex flex-col grow pb-16 w-full rounded-2xl bg-slate-200 text-zinc-800 max-md:mt-10 max-md:max-w-full">
              <img
                loading="lazy"
                src={Iauto3}
                className="w-full aspect-[1.39] max-md:max-w-full"
              />
              <div className="flex flex-col px-16 mt-11 max-md:px-5 max-md:mt-10 max-md:max-w-full">
                <div className="text-4xl font-extrabold capitalize max-md:max-w-full">
                  Automatedenergy storage
                </div>
                <div className="mt-12 text-lg leading-7 max-md:mt-10 max-md:max-w-full">
                  leading renewable energy solutions provider that is sources
                  are harnessed across the world. Present in 18 countries across
                  Asia, Australia, Europe Africa and the Americas, Veztaz is
                  powering.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="mt-28 w-full max-md:mt-10 max-md:max-w-full">
        <div className="flex gap-5 max-md:flex-col max-md:gap-0">
          <div className="flex flex-col w-6/12 max-md:ml-0 max-md:w-full">
            <div className="flex flex-col grow pb-16 w-full rounded-2xl bg-slate-200 text-zinc-800 max-md:mt-10 max-md:max-w-full">
              <img
                loading="lazy"
                src={Iauto4}
                className="w-full aspect-[1.39] max-md:max-w-full"
              />
              <div className="flex flex-col px-16 mt-11 max-md:px-5 max-md:mt-10 max-md:max-w-full">
                <div className="text-4xl font-extrabold capitalize max-md:max-w-full">
                  Automatedenergy storage
                </div>
                <div className="mt-12 text-lg leading-7 max-md:mt-10 max-md:max-w-full">
                  leading renewable energy solutions provider that is sources
                  are harnessed across the world. Present in 18 countries across
                  Asia, Australia, Europe Africa and the Americas, Veztaz is
                  powering.
                </div>
              </div>
            </div>
          </div>
          <div className="flex flex-col ml-5 w-6/12 max-md:ml-0 max-md:w-full">
            <div className="flex flex-col grow pb-16 w-full rounded-2xl bg-slate-200 text-zinc-800 max-md:mt-10 max-md:max-w-full">
              <img
                loading="lazy"
                src={Iauto5}
                className="w-full aspect-[1.39] max-md:max-w-full"
              />
              <div className="flex flex-col px-16 mt-11 max-md:px-5 max-md:mt-10 max-md:max-w-full">
                <div className="text-4xl font-extrabold capitalize max-md:max-w-full">
                  Automatedenergy storage
                </div>
                <div className="mt-12 text-lg leading-7 max-md:mt-10 max-md:max-w-full">
                  leading renewable energy solutions provider that is sources
                  are harnessed across the world. Present in 18 countries across
                  Asia, Australia, Europe Africa and the Americas, Veztaz is
                  powering.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Section2;
